import React, { FC } from 'react';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { NavigationContentLink, NavigationContentLinkTitle } from '../../Links/Links';
import { replaceSpaceWithDash } from '../../../helpers/helpers';

interface LinksProps {
  name: string;
  url: string;
}

interface NavigationLinksProps {
  color: string;
  links: LinksProps[];
  title: string;
  url: string;
}

type TitleAttributesProps = {
  color: string;
  href?: string;
  id: string;
};

const NavigationLinks: FC<NavigationLinksProps> = ({ color, links, title, url }) => {
  const { localized } = useUrlBuilder();
  const titleAttributes: TitleAttributesProps = {
    color,
    id: `nav-title-sublink-${replaceSpaceWithDash(title)}`,
  };
  if (url) {
    titleAttributes.href = localized(url);
  }
  return (
    <>
      <NavigationContentLinkTitle {...titleAttributes}>{title}</NavigationContentLinkTitle>{' '}
      <div className="navigation-content-list">
        {links.map(l => (
          <NavigationContentLink
            key={l.name}
            href={localized(`${l.url}`)}
            id={`nav-sublink-${l.name.replace(/\s/g, '-')}`}
          >
            {l.name}
          </NavigationContentLink>
        ))}
      </div>
      <style jsx>
        {`
          .navigation-content-list {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            margin-top: 10px;
          }
        `}
      </style>
    </>
  );
};

export { NavigationLinks };
